import { render, staticRenderFns } from "./PorletDashboardDOOX.vue?vue&type=template&id=41a67a48"
import script from "./PorletDashboardDOOX.vue?vue&type=script&lang=js"
export * from "./PorletDashboardDOOX.vue?vue&type=script&lang=js"
import style0 from "./PorletDashboardDOOX.vue?vue&type=style&index=0&id=41a67a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports